import {Container} from 'pixi.js';
import {UpdateManager, inject} from '@gongxigames/framework/core';
import {View} from '@gongxigames/framework/slot/fragments/module/view';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {IReelsScaleService} from '@gongxigames/framework/slot/types';

export class PickBonusView extends View<GlobalEventsMapForBackwardCompatibility> {
    public static readonly NAME: symbol = Symbol('PickBonusView');

    public static readonly UPDATE_PICKED: symbol = Symbol('UPDATE_PICKED');

    protected _baseContainer: Container = new Container();
    protected _updater: UpdateManager = new UpdateManager(true);

    @inject(DI.ReelsScaleService)
    protected _reelsScaleService!: IReelsScaleService;

    public init(): void {
        super.init();

        this.container.addChild(this._baseContainer);
        this.updateManager.add(this._updater);
    }

    public start(_pickedValues: number[][]): void {
    }

    public stop(): void {
        this._updater.removeAll();
        this._baseContainer.removeChildren();
    }

    public pick(index: number, value: number): void {
        this.emit(PickBonusView.UPDATE_PICKED, index, value);
    }

    public onOrientationChanged(): void {
        super.onOrientationChanged();

        this._reelsScaleService.scaleByCurrentScreenOrientation(this._baseContainer);

    }
}
